/**
 * Maximum retry delay (60 seconds for rate-limited APIs)
 */
export const MAX_RETRY_DELAY_MS = 60000;

/**
 * Default minimum delay for 429 errors (1 second)
 */
export const DEFAULT_429_DELAY_MS = 1000;
